
// import Swal from "sweetalert2";
const state = {};

const mutations = {};

const actions = {
    success ({ commit, dispatch }, message) {
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: 'add_alert',
            type: 'success'
        });
    },

    error ({ commit, dispatch }, message) {
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: 'add_alert',
            type: 'warning'
        });
    },
    danger ({ commit, dispatch }, message) {
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: 'report_problem',
            type: 'danger'
        });
    },
    info ({ commit, dispatch }, message) {
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: 'info_alert',
            type: 'info'
        });
    },
    warning ({ commit, dispatch }, message) {
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: 'warning_alert',
            type: 'warning'
        });
    },
    alert ({ commit, dispatch }, response) {
        let payloadType = typeof response;
        let status = response ? response.status : 600;
        let type = 'warning';
        let icon = 'warning';
        let message = '';
        if (payloadType === 'string') {
            message = response;
            status = 444;
        }
        switch (status) {
        case 403:
            type = 'danger';
            icon = 'report_problem';
            message = response.data.errors[0].title;
            break;
        case 422:
            message = response.data.errors[0].detail;
            break;
        case 400:
            type = 'danger';
            icon = 'nearby_error';
            message = response.data.errors[0].title;
            break;
        case 404:
            type = 'danger';
            icon = 'nearby_error';
            message = response.data.errors[0].detail;
            break;
        case 444:
            type = 'warning';
            icon = 'nearby_error';
            break;
        case 500:
            type = 'danger';
            icon = 'gpp_bad';
            message = 'Oops! Server error.. Something went wrong. please contact your administrator';
            break;
        default:
            message = 'Oops! Something went wrong. please contact your administrator or check your inputs';
            break;
        }
        this.$app.$notify({
            timeout: getTimeOut(message),
            message: message,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            icon: icon,
            type: type
        });
    }
};

const getters = {};

const alerts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

function getTimeOut (message) {
    let length = 5;
    if (typeof message !== 'undefined') {
        length = message.split(' ').length;
    }
    if (length < 3) {
        return 3000;
    }
    if (length > 10) {
        return 10000;
    }
    return length * 1000;
}

export default alerts;
